import Main from './ChurnReasonsMain'
import New from './ChurnReasonsNew'
import Edit from './ChurnReasonsEdit'

const ChurnReasons = {
  Main,
  New,
  Edit,
}

export default ChurnReasons
